import { EBitfStoreActions } from '@common/enums';
export enum EAppActions {
  BAR_CODE_RECEIVED = 'BAR_CODE_RECEIVED',
  SELECTED_DATE_CHANGED = 'SELECTED_DATE_CHANGED',
}

export const EStoreActions = { ...EBitfStoreActions, ...EAppActions };
